import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import ReactTooltip from "react-tooltip";
import Scrollbar from "react-scrollbars-custom";
import { ReactSVG } from "react-svg";
import { getFormattedDateTime, getDateFromTimeStamp } from "../../helpers/formatters";
import userEvent from "@testing-library/user-event";
import { getFormattedDate } from "./../../helpers/formatters";
import i18n from "./../../i18n";
import OutsideClickHandler from "react-outside-click-handler";

function ConversationBody({ messages, isLoading, scrolltop, getConversationContent, oponentId, isgroup, loadMore, user }) {
  let scrollComponent = useRef(null);
  useLayoutEffect(() => {
    if (isLoading) return;
    setTimeout(() => {
      if (scrollComponent.current) {
        if (!scrolltop) scrollComponent.current.scrollToBottom();
        else scrollComponent.current.scrollTo(0, 500);
      }
    }, 40);
  }, [messages, scrolltop, isLoading]);

  const onUpdateScrollbar = () => {
    if (!isLoading && scrollComponent.current.scrollValues.scrollTop === 0 && loadMore) {
      setTimeout(() => {
        if (!isLoading && scrollComponent.current.scrollValues.scrollTop === 0 && loadMore)
          getConversationContent(oponentId, isgroup, true);
      }, 100);
    }
  };

  const [messageDropdown, setMessageDropdown] = useState(false);

  const showMessageDropdownMenu = () => {
    setMessageDropdown(true);
  };

  return (
    <div className="chat-content p-2" id="messageBody">
      {/* onUpdate={() => onUpdateScrollbar()} */}
      <Scrollbar ref={scrollComponent}>
        <div className="container">
          {!isLoading && loadMore && (
            <div className="date-seperator">
              <span
                style={{ cursor: "pointer", fontSize: "15px" }}
                onClick={() => getConversationContent(oponentId, isgroup, true)}
              >
                {i18n.t("show_more")}
              </span>
            </div>
          )}
          <div className="message-day">
            {messages && messages.length > 0
              ? messages &&
                messages.map((item, id) => (
                  <div key={id}>
                    {(id === 0 ||
                      getDateFromTimeStamp(messages[id - 1].messageSendDate) !== getDateFromTimeStamp(item.messageSendDate)) && (
                      <div className="date-seperator">
                        <span>{getFormattedDate(item.messageSendDate)}</span>
                      </div>
                    )}
                    <div className={item.id === user.id ? "message self" : "message"}>
                      <div className="message-wrapper">
                        <div className="message-content">
                          <span>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: item.messageText,
                              }}
                            />
                          </span>
                          {!!item.messageFile && item.messageFile.length > 0 && (
                            <div className="form-row">
                              {item.messageFile.map((f) => (
                                <div className="file-item" key={f.id}>
                                  <ReactSVG src="/media/img-icon.svg" />
                                  <div className="file-info">
                                    <h4 title={f.name}>{f.name}</h4>
                                    {/* <p>{f.size}</p> */}
                                  </div>
                                  <a href={`/api/messenger/get-file?id=${f.id}`} target="_blank">
                                    <span className="material-icons">cloud_download</span>
                                  </a>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="message-options">
                        <div className="avatar avatar-sm" data-tip data-for={"tooltip" + id}>
                          {(isgroup || !!item.messageSeenDate) && (
                            <ReactTooltip id={"tooltip" + id} type="info" place={item.id === user.id ? "left" : "right"}>
                              {isgroup ? (
                                <span>{item.personName}</span>
                              ) : (
                                <span>{`${i18n.t("seen")} ${getFormattedDateTime(item.messageSeenDate, true)}`}</span>
                              )}
                            </ReactTooltip>
                          )}
                          <img alt="" src={item.avatar} />
                        </div>
                        <span className="message-date">{getFormattedDateTime(item.messageSendDate)}</span>

                        {/* {item.id === user.id && (
                          <div className="dropdown">
                            <div className="dropdown-btn" onClick={showMessageDropdownMenu}>
                              <svg className="hw-18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"
                                ></path>
                              </svg>
                            </div>
                            {messageDropdown && (
                              <OutsideClickHandler
                                onOutsideClick={() => {
                                  setMessageDropdown(false);
                                }}
                              >
                                <div className="dropdown-menu">
                                  <div className="dropdown-item d-flex align-items-center text-danger">
                                    <svg className="hw-18 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                      ></path>
                                    </svg>

                                    <span>Delete</span>
                                  </div>
                                </div>
                              </OutsideClickHandler>
                            )}
                          </div>
                        )} */}
                      </div>
                    </div>
                  </div>
                ))
              : isLoading && (
                  <>
                    <div className="message self isLoading">
                      <div className="message-wrapper">
                        <div className="message-content">
                          <span></span>
                        </div>
                      </div>
                      <div className="message-options">
                        <div className="avatar avatar-sm">
                          <img alt="" src="" />
                        </div>
                        <span className="message-date"></span>
                      </div>
                    </div>
                    <div className="message isLoading">
                      <div className="message-wrapper">
                        <div className="message-content">
                          <span></span>
                        </div>
                      </div>
                      <div className="message-options">
                        <div className="avatar avatar-sm">
                          <img alt="" src="" />
                        </div>
                        <span className="message-date"></span>
                      </div>
                    </div>
                    <div className="message self isLoading">
                      <div className="message-wrapper">
                        <div className="message-content">
                          <span></span>
                        </div>
                      </div>
                      <div className="message-options">
                        <div className="avatar avatar-sm">
                          <img alt="" src="" />
                        </div>
                        <span className="message-date"></span>
                      </div>
                    </div>
                    <div className="message isLoading">
                      <div className="message-wrapper">
                        <div className="message-content">
                          <span></span>
                        </div>
                      </div>
                      <div className="message-options">
                        <div className="avatar avatar-sm">
                          <img alt="" src="" />
                        </div>
                        <span className="message-date"></span>
                      </div>
                    </div>
                  </>
                )}
          </div>
        </div>
        <div className="chat-finished" id="chat-finished"></div>
      </Scrollbar>
    </div>
  );
}

export default ConversationBody;
